export default "__VITE_ASSET__D39QIKOO__"